export enum PurchasableState {
  ACTIVE = "ACTIVE",
  PROTO = "PROTO",
  REVOKED = "REVOKED",
  REVOKED_REFUNDED = "REVOKED_REFUNDED",
  REVOKED_REFUNDED_PARTIALLY = "REVOKED_REFUNDED_PARTIALLY",
  VOIDED = "VOIDED",
}
